<script setup lang="ts">
import { computed } from 'vue'
import { marked } from 'marked'

// Contenu rédigé exclusivement par les SUPER_ADMIN (même niveau de confiance
// que les pages légales / bandeaux) — rendu direct sans sanitisation.
const props = defineProps<{ content: string }>()

const html = computed(() => marked.parse(props.content ?? '', { async: false }) as string)
</script>

<template>
  <div class="markdown-content text-sm" v-html="html" />
</template>

<style scoped>
.markdown-content :deep(h1),
.markdown-content :deep(h2),
.markdown-content :deep(h3) {
  font-weight: 600;
  margin: 0.75rem 0 0.35rem;
}

.markdown-content :deep(h1) {
  font-size: 1.15rem;
}

.markdown-content :deep(h2) {
  font-size: 1.05rem;
}

.markdown-content :deep(h3) {
  font-size: 0.95rem;
}

.markdown-content :deep(p) {
  margin: 0.35rem 0;
}

.markdown-content :deep(ul),
.markdown-content :deep(ol) {
  margin: 0.35rem 0 0.35rem 1.25rem;
  list-style: disc;
}

.markdown-content :deep(ol) {
  list-style: decimal;
}

.markdown-content :deep(li) {
  margin: 0.2rem 0;
}

.markdown-content :deep(a) {
  text-decoration: underline;
  color: var(--color-primary);
}

.markdown-content :deep(code) {
  font-family: ui-monospace, monospace;
  font-size: 0.85em;
  background: var(--color-base-200);
  padding: 0.1rem 0.3rem;
  border-radius: 0.25rem;
}

.markdown-content :deep(blockquote) {
  border-left: 3px solid var(--color-base-300);
  padding-left: 0.75rem;
  opacity: 0.8;
  margin: 0.5rem 0;
}
</style>
